import { render, staticRenderFns } from "./CReportItem.vue?vue&type=template&id=e36bdf7c&scoped=true&"
import script from "./CReportItem.vue?vue&type=script&lang=js&"
export * from "./CReportItem.vue?vue&type=script&lang=js&"
import style0 from "./CReportItem.vue?vue&type=style&index=0&id=e36bdf7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36bdf7c",
  null
  
)

export default component.exports